export default "__VITE_ASSET__BlmQ1VuW__"